// /admin/infraestructura
// Pantalla de status técnico del sistema (todo lo de Cloudflare, Supabase, APIs).
// Se sacó del Dashboard principal porque ese es para métricas de negocio,
// no de plataforma. Acceso desde el sidebar (link directo) y desde el indicador
// de status del sidebar.

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import AdminLayout from '../../components/AdminLayout'
import SystemStatusSection from '../../components/SystemStatusSection'
import LivePresenceCounter from '../../components/LivePresenceCounter'
import HistoricoIncidencias from '../../components/HistoricoIncidencias'
import LatenciaTrend from '../../components/LatenciaTrend'

export default function Infraestructura() {
  return (
    <AdminLayout title="Infraestructura">
      <div className="infra-page">
        <header className="infra-head">
          <h1>⚡ Infraestructura</h1>
          <p>
            Estado en vivo de los sistemas que hacen funcionar Limpack — sitios web, backend Supabase,
            edge functions, APIs externas, flags y configs. Auto-refresca cada 30 segundos.
          </p>
        </header>

        {/* Quién está navegando en vivo — antes en el sidebar */}
        <LivePresenceCounter />

        {/* Estado del sistema completo con drawer de detalle */}
        <SystemStatusSection />

        <section className="infra-card" style={{ background: '#EFF6FF', borderColor: '#BFDBFE' }}>
          <h2 style={{ color: '#1E3A8A' }}>📲 Alertas al celular</h2>
          <p style={{ color: '#1E40AF' }}>
            Configurás destinatarios de WhatsApp que reciben aviso automático cuando algo se cae o se recupera.
            El cron <code>alertador-sistema-cada-5min</code> chequea sitios + Supabase cada 5 minutos.
          </p>
          <Link to="/admin/infraestructura/alertas" style={{
            display: 'inline-block', marginTop: 8, background: '#1A3461', color: '#fff',
            padding: '9px 18px', borderRadius: 8, textDecoration: 'none', fontWeight: 800, fontSize: 13
          }}>Configurar alertas →</Link>
        </section>

        <section className="infra-card">
          <h2>📚 Manuales operativos</h2>
          <p>Si algo está rojo y necesitás resolverlo, los manuales del runbook tienen los pasos:</p>
          <ul>
            <li>📄 <strong>Runbook Operativo</strong> — qué hacer cuando algo se rompe (entregas, cobros, sistemas caídos). Disponible en <code>/admin/docs</code>.</li>
            <li>🧑‍💻 <strong>Manual técnico de onboarding</strong> — setup local, Supabase, Cloudflare, deploys.</li>
            <li>💼 <strong>Brief de infraestructura ($50/mes)</strong> — propuesta para Roberto sobre Supabase Pro + CF Workers Paid + CF Pro.</li>
          </ul>
        </section>

        {/* Histórico de incidencias — desde sistema_alertas_log */}
        <HistoricoIncidencias />

        {/* Latencia trend 7 días — desde v_health_latencia_7d */}
        <LatenciaTrend />

        <Estilos />
      </div>
    </AdminLayout>
  )
}

function Estilos() {
  return (
    <style>{`
      .infra-page { max-width: 1200px; margin: 0 auto; padding: 24px; font-family: Inter, system-ui, sans-serif; color: #1A3461; }
      .infra-head { margin-bottom: 22px; }
      .infra-head h1 { margin: 0 0 6px; font-size: 24px; font-weight: 900; letter-spacing: -0.02em; }
      .infra-head p { margin: 0; font-size: 13.5px; color: #64748B; line-height: 1.55; max-width: 720px; }

      .infra-card {
        background: #fff; border: 1px solid #E2E8F0; border-radius: 12px;
        padding: 18px 22px; margin-bottom: 14px;
      }
      .infra-card h2 { margin: 0 0 8px; font-size: 15px; font-weight: 800; color: #1A3461; }
      .infra-card p { margin: 0 0 8px; font-size: 13.5px; color: #475569; line-height: 1.5; }
      .infra-card ul { margin: 6px 0 0; padding-left: 20px; font-size: 13px; line-height: 1.7; color: #475569; }
      .infra-card li { margin: 4px 0; }
      .infra-card code { background: #F1F5F9; padding: 1px 6px; border-radius: 4px; font-family: 'SF Mono', monospace; font-size: 12px; color: #1A3461; }
      .infra-card strong { color: #1A3461; }
    `}</style>
  )
}
